import * as moment from 'moment'

export function humanizeEdeliveryStatus (status) {
  // translates event_status value to human string. Now we have only 1 value to translate
  return status === 'ALLOWED FOR IMPORT' ? 'APPROVED FOR E-DELIVERY': status
}

export function getEdeliveryRowCssStyleByStatus (status) {
  let matchDict = {
    'CREATED': 'created-row',
    'PENDING': 'pending-row',
    'NOTIFIED': 'notified-row',
    'DO NOT SEND': 'do-not-send-row',
    'FAILED': 'failed-row',
    'NO EDELIVERY EXPECTED': 'no-delivery-expected-row',
    'DATA CORRUPTED': 'data-corrupted-row',
    'WAITING FOR APPROVAL': 'waiting-for-approval-row',
    'ALLOWED FOR IMPORT': 'allowed-for-import-row',
    'EXCLUDE FROM EDELIVERY': 'exclude-from-edelivery-row',
    "EXCLUDE AND DON'T PRINT": 'exclude-and-dont-print-row',
    'TEMPORARY FAILURE': 'temporary-failed-row',
    'WAITING FOR ENROLLMENT': 'waiting-for-enrollment-row'
  }
  return matchDict[status] || ''
}

export function convertDateToYYYYMMDD (date) {
  return moment(date).format('YYYY-MM-DD')
}

export let emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/ // eslint-disable-line

export function copyToClipboard (valueToCopy) {
  const el = document.createElement('textarea')
  el.value = valueToCopy
  document.body.appendChild(el)
  el.select()
  document.execCommand('copy')
  document.body.removeChild(el)
}
